import { useState, useEffect, useCallback } from "react";
import { fetchAndActivate, getValue } from "firebase/remote-config";
import { remoteConfig } from "../firebase/firebase";

export interface UseMultiCashoutEnabledReturn {
  isMultiCashoutEnabled: boolean;
  isLoadingMultiCashoutFlag: boolean;
}

export const useMultiCashoutEnabled = (): UseMultiCashoutEnabledReturn => {
  const [isEnabled, setIsEnabled] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);

  const fetchRemoteConfig = useCallback(async () => {
    try {
      setLoading(true);
      await fetchAndActivate(remoteConfig);
      const multiCashoutEnabled = getValue(
        remoteConfig,
        "multi_cashout_enabled"
      ).asBoolean();
      setIsEnabled(multiCashoutEnabled);
    } catch (error) {
      console.error("Error fetching multi_cashout_enabled config:", error);
      setIsEnabled(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchRemoteConfig();
  }, [fetchRemoteConfig]);

  return {
    isMultiCashoutEnabled: isEnabled,
    isLoadingMultiCashoutFlag: loading,
  };
};
